const PropTypes = require('prop-types');
const React = require('react');
const CanadianRoutingNumberFields = require('../canadian_routing_number_fields.jsx');
const CountryCodeInput = require('./country_code_input.jsx');
const CurrencyInput = require('./currency_input.jsx');
const CurrencyWarnings = require('components/shop/direct_checkout_profile/currency_warnings.jsx');
const ErrorMessage = require('components/shared/error_message.jsx');
const ACCOUNT_INPUT_LENGTH = 17;
const EXAMPLE_CHECK_IMAGE = require('../../../../../images/listing-form/canadian-example-check.png');
const { CURRENCY_CODES } = require('components/shared/constants.js');
const CANADIAN_DOLLAR = CURRENCY_CODES.CAD;
const CANADA = 'CA';

class CanadianBankFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      routingNumberError: null,
      showValidBankInfo: false,
      bankName: '',
      routingNumber: '',
    };
  }

  verifyRoutingNumber(transitNumber, institutionNumber) {
    const req = $.ajax({
      type: 'get',
      url: this.props.bankLookupUrl,
      dataType: 'text',
      data: {
        transit_number: transitNumber,
        institution_number: institutionNumber,
        country_code: CANADA,
      },
    });

    req.success((response) => this.success(response));
    req.fail((response) => this.fail(response));
  }

  success(response) {
    this.setState({
      routingNumberError: false,
      showValidBankInfo: true,
      bankName: JSON.parse(response).name,
    });
  }

  fail() {
    this.setState({
      routingNumberError: I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.invalidRouting'),
      showValidBankInfo: false,
      bankName: '',
      routingNumber: '',
    });
  }

  displayValidBankInfo() {
    if (!this.state.showValidBankInfo) { return false; }
    return (
      <div>
        <hr />
        <p className="mb-0">
          <b>{this.state.bankName}</b>
        </p>
        <hr className="mb-1" />
      </div>
    );
  }

  displayRoutingNumberError() {
    if (!this.state.routingNumberError) { return false; }

    return (
      <ErrorMessage
        message={this.state.routingNumberError}
        alertStyle="alert-warn alert-small"
      />
    );
  }

  hasValidSelectedPayoutCurrency() {
    return !!this.props.currencies.find((currency) => currency.code === this.props.selectedPayoutCurrency);
  }

  currencyForInput() {
    if (this.hasValidSelectedPayoutCurrency()) {
      return this.props.selectedPayoutCurrency;
    }

    return CURRENCY_CODES.CAD;
  }

  bankLocationDetailsInput() {
    return (
      <div className="mb-1">
        <div className="g-container">
          <CountryCodeInput
            countryCode={CANADA}
            countryCodeOptions={this.props.countryCodeOptions}
            nameForField={(fieldName) => this.props.nameForField(fieldName)}
            onCountryChange={(countryCode) => this.props.onCountryChange(countryCode)}
          />
          <CurrencyInput
            selectedPayoutCurrency={this.currencyForInput()}
            currencies={this.props.currencies}
            nameForField={(fieldName) => this.props.nameForField(fieldName)}
            onCurrencyChange={(currencyCode) => this.props.onCurrencyChange(currencyCode)}
          />
        </div>

        <CurrencyWarnings
          payoutCurrency={this.currencyForInput()}
          defaultCurrencyForBankCountry={CANADIAN_DOLLAR}
          shopCurrency={this.props.shopCurrency}
          dashboardView={this.props.dashboardView}
          nameForField={this.props.nameForField}
          hasLayawayEnabled={this.props.hasLayawayEnabled}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="g-container mb-1">
          <div className="g-col-6 g-col-mobile-12">
            <label>
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.nameOnAccount')}
            </label>
            <input
              className="string required wide mb-0"
              autoFocus="on"
              type="text"
              name={this.props.nameForField('name_on_account')}
            />
          </div>
        </div>

        {this.bankLocationDetailsInput()}

        <div className="g-container">
          <div className="g-col-8 g-col-mobile-12">
            <CanadianRoutingNumberFields
              verifyRoutingNumber={(transitNumber, institutionNumber) =>
              this.verifyRoutingNumber(transitNumber, institutionNumber)}
              nameForField={(fieldName) => this.props.nameForField(fieldName)}
            />
          </div>

          <div className="g-col-4 g-col-mobile-12">
            <label
              className="string required control-label"
              dangerouslySetInnerHTML={{
                __html: I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.canada.accountNumber', {
                  hint_open: '<span class="hint">',
                  hint_close: '</span>' }
               ) }}
            />
            <input
              className="string required wide"
              maxLength={ACCOUNT_INPUT_LENGTH}
              type="text"
              name={this.props.nameForField('bank_account_number')}
            />
          </div>
        </div>
        {this.displayRoutingNumberError()}
        {this.displayValidBankInfo()}
        <div className="toggler mb-0" rel="example-check">
          <a className="small" href="#">
            {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.canada.findBankNumbers')}
          </a>
        </div>
        <div className="toggleable ptb-1" id="example-check">
          <img
            src={EXAMPLE_CHECK_IMAGE}
            className="example-check-img"
            alt={I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.exampleCheckAlt')}
          />
        </div>
      </div>
    );
  }
}

CanadianBankFields.propTypes = {
  bankLookupUrl: PropTypes.string.isRequired,
  countryCodeOptions: PropTypes.array.isRequired,
  nameForField: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  currencies: PropTypes.array.isRequired,
  selectedPayoutCurrency: PropTypes.string.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  hasLayawayEnabled: PropTypes.bool.isRequired,
  dashboardView: PropTypes.bool.isRequired,
};

module.exports = CanadianBankFields;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/bank_account_fields/canadian_bank_fields.jsx